<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>Dosya Bilgileri Ekranı</h1>
          </div>
  
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">Dosya Bilgileri</a></li>
          </ul>
        </div>
        <div class="row form-margin">
          <div class="col-md-12 tex-center d-flex align-items-center flex-column">
            <div class="tile">
              <h3 class="tile-title">Dosya Bilgileri</h3>
              <div class="tile-body">
                <form>
                  <div class="form-group">
                    <label class="control-label">Dosya Adı:</label>
                    <label class="form-control">{{ result.filename }}</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Dosya Açıklaması:</label>
                    <label class="form-control">{{ result.filecontent }}</label>
                  </div>
  
                  <div class="form-group">
                    <label class="control-label">Dosya Linki:</label>
                    <a style="color:red" :href="result.fullpath" target="_blank" class="form-control">{{ result.pathname }}</a>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Sınıf:</label>
                    <label class="form-control">{{ result.class }}</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Yükleyen Kullanıcı Adı Ve Soyadı:</label>
                    <label class="form-control">{{ result.userNameSurname }}</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Yüklenme Tarihi:</label>
                    <label class="form-control">{{ result.reg_date }}</label>
                  </div>
                </form>
              </div>
              <div class="tile-footer">
                <button
                  @click="confirmNote()"
                  class="btn btn-success fileupload-exists"
                >
                  <i class="fa fa-trash-o"></i>Notu Onayla
                </button>
                <button
                  @click="deleteNote()"
                  class="btn btn-danger fileupload-exists"
                >
                  <i class="fa fa-trash-o"></i>Notu Reddet
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        result: {
          id: "",
          filename: "",
          filecontent: "",
          class: "",
          pathname: "",
          fullpath: "",
          userId: "",
          userNameSurname: "",
          img_url: "",
          imgSrc: store.state.img_base_url,
        },
        id: this.$route.query.id,
      };
    },
    methods: {
      deleteNote: function() {
        var url = store.state.base_url + "Admin/deleteNote.php?key=123";
  
        var datas = {
          id: localStorage.getItem("id"),
          admin_token: localStorage.getItem("admin_token"),
          noteId: this.id,
          userId: this.result.userId,
        };
  
        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
              console.log(response.data)
            if (response.data.dataDelete == true) {
              // location.reload();
              this.$swal({
                text: "Öğrenci Notu Başarıyla Silindi",
                icon: "success",
                closeOnClickOutside: false,
              });
              window.location.href = "#/fileConfirmation";
            }
            //////////console.log(response);
          })
          .catch((error) => {
            //////console.log(error.response);
          });
      },
      confirmNote: function() {
        var url = store.state.base_url + "Admin/confirmNote.php?key=123";
  
        var datas = {
          id: localStorage.getItem("id"),
          admin_token: localStorage.getItem("admin_token"),
          noteId: this.id,
          userId: this.result.userId,
        };
  
        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
              console.log(response.data)
            if (response.data.update == true) {
              // location.reload();
              this.$swal({
                text: "Öğrenci Notu Başarıyla Onaylandı",
                icon: "success",
                closeOnClickOutside: false,
              });
              window.location.href = "#/fileConfirmation";
            }
            //////////console.log(response);
          })
          .catch((error) => {
            //////console.log(error.response);
          });
      },
    },
    mounted: function() {
      window.scrollTo(0, 0);
      var admin_token = localStorage.getItem("admin_token");
      var token = localStorage.getItem("token");
    if (!token) {
      alert("Yetkisiz İşlem Yapılmaya Çalışıldı Giriş Sayfasına Yönlendirileceksiniz")
      this.$store.dispatch("logout");
    }
      var datas = {
        id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("admin_token"),
        noteId: this.id,
      };
  
      let dataUrl =
        store.state.base_url + "Admin/getByNoteDetail.php?key=123";
      return axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
        this.datas = response.data.data;
        this.userData = response.data.user;
        this.result.id = this.datas.id;
        this.result.filename = this.datas.filename;
        this.result.filecontent = this.datas.filecontent;
        this.result.pathname = this.datas.pathname;
        this.result.fullpath ="https://www.file.dosya.aslanyazilimm.com/Notes/"  + this.datas.pathname;
        this.result.class = this.datas.class;
        this.result.userId = this.userData.id;
        this.result.userNameSurname = this.userData.name + " " + this.userData.surname;
        this.result.reg_date = this.datas.reg_date;
      });
    },
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/NotesDetail.vue